import { render } from "./HeroiconsSolidPencil.vue?vue&type=template&id=2fc00666"
const script = {}

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPencil.vue"]])

export default __exports__